import React, { useState, useEffect, useRef } from "react";
import Request from "../../utils/http";
import Modal from "react-modal";
import ItemStage from "./itemStage";

const request = new Request();
function InputsInventory(props) {
  const [modal, setModal] = useState(false);
  const [etapa, setEtapa] = useState('');
  const [stage, setStage] = useState(0);
  const customStyles = {
    content: {
      position: "absolute",
      top: "10%",
      left: "10%",
      right: "10%",
      bottom: "10%",
      border: "1px solid rgb(204, 204, 204)",
      background: "rgb(255, 255, 255)",
      overflow: "auto",
      outline: "none",
      padding: "10px",
    },
  };
  return (
    <>
      <table style={{ width: "100%" }}>
        <tr>
          <th className="text-sm">SALIDAS</th>
          <td>
            <button
              className="btn btn-info bg-gradient-info"
              title="Etapa 1. Preparar artículo para el evento."
              style={{ width: "3rem" }}
              onClick={(e) => {
                setEtapa(e.target.title);
                setStage(1);
                setModal(true);
                }}
            >
              <i className="fas fa-clipboard-list"></i>
            </button>
          </td>
          <td>
            <button
              className="btn btn-info bg-gradient-info"
              title="Etapa 2. Concentrar artículo para el evento."
              style={{ width: "3rem" }}
              onClick={(e) => {
                setEtapa(e.target.title);
                setStage(2);
                setModal(true);
                }}
            >
              <i className="fas fa-boxes"></i>
            </button>
          </td>
          <td>
            <button
              className="btn btn-info bg-gradient-info"
              title="Etapa 3. Entrega artículo para el evento."
              style={{ width: "3rem" }}
              onClick={(e) => {
                setEtapa(e.target.title);
                setStage(3);
                setModal(true);
                }}
            >
              <i className="fas fa-dolly"></i>
            </button>
          </td>
          <td>
            <button
              className="btn btn-info bg-gradient-info"
              title="Etapa 4. Descargar y montar artículo para el evento."
              style={{ width: "3rem" }}
              onClick={(e) => {
                setEtapa(e.target.title);
                setStage(4);
                setModal(true);
                }}
            >
              <i className="fas fa-truck-loading"></i>
            </button>
          </td>
        </tr>
        <tr>
          <th className="text-sm">ENTRADAS</th>
          <td>
            <button
              className="btn btn-info bg-gradient-info"
              title="Etapa 5. Desmonta artículo del evento."
              style={{ width: "3rem" }}
              onClick={(e) => {
                setEtapa(e.target.title);
                setStage(5);
                setModal(true);
                }}
            >
              <i className="fas fa-people-carry"></i>
            </button>
          </td>
          <td>
            <button
              className="btn btn-info bg-gradient-info"
              title="Etapa 6. Descarga artículo en bodega."
              style={{ width: "3rem" }}
              onClick={(e) => {
                setEtapa(e.target.title);
                setStage(6);
                setModal(true);
                }}
            >
              <i className="fas fa-warehouse"></i>
            </button>
          </td>
          <td>
            <button
              className="btn btn-info bg-gradient-info"
              title="Etapa 7. Recibe artículo en bodega."
              style={{ width: "3rem" }}
              onClick={(e) => {
                setEtapa(e.target.title);
                setStage(7);
                setModal(true);
                }}
            >
              <i className="fas fa-dolly-flatbed"></i>
            </button>
          </td>
          <td>
            <button
              className="btn btn-info bg-gradient-info"
              title="Etapa 8. Guarda artículo en almacen."
              style={{ width: "3rem" }}
              onClick={(e) => {
                setEtapa(e.target.title);
                setStage(8);
                setModal(true);
                }}
            >
              <i className="fas fa-clipboard-check"></i>
            </button>
          </td>
        </tr>
      </table>

      <Modal isOpen={modal} contentLabel="Zoom Imagen" style={customStyles}>
        <div className="modal-header">
          <h4 className="modal-title">{etapa}</h4>
          <button
            type="button"
            className="close"
            onClick={() => {
              setModal(false);
              setEtapa('');
              setStage(0);
            }}
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="text-center">
            <ItemStage stage={stage} eve={props.eve} sub={props.sub} info={props.info} img={props.img} />
          </div>
        </div>
      </Modal>
    </>
  );
}
export default InputsInventory;
